import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'

const DiagnosticEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection showTransportAutoEntriesDeliveryCodeWithComplete />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  )
}

export default DiagnosticEntryOnGoingCheckin
